import page43 from "./Page43.webp";
import page44 from "./Page44.webp";
import page45 from "./Page45.webp";

export const softRetroPages = [page43, page44, page45];
